import React, { useState, useEffect } from 'react'
import { Panel, Form, FormGroup, Row, Col, Input, Message } from 'rsuite'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import { requiredFiled, isValidators, getMaxLengthData } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import InputNumberForm from '../../../../components/forms/input/InputNumberForm'
import InputForm from '../../../../components/forms/input/InputForm'

export default function OrganicVegetablesBGForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
}) {
  return (
    <>
      {schema.communityBackground && (
        <Panel header={schema.communityBackground.label}>
          {schema.description && <CustomIconMessageInfo contents={schema.description} />}

          {schema.message &&
            schema.message.map((item) => {
              return <Message showIcon type={item.type} description={item.description} />
            })}

          <Form fluid>
            <FormGroup>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={Styles.marginTop3}>
                  <ErrorMessage error={errors[schema.communityBackground.community.name]} />
                </Col>
                <Col xs={24} sm={24} md={4} lg={4} style={Styles.marginTop3}>
                  <p style={Styles.marginTop5}>
                    {requiredFiled(
                      schema.communityBackground.community.validators,
                      schema.communityBackground.community.label
                    )}
                  </p>
                </Col>
                <Col xs={24} sm={24} md={20} lg={20} style={Styles.marginTop3}>
                  <Input
                    style={{ width: '300px' }}
                    name={schema.communityBackground.community.name}
                    defaultValue={schema.communityBackground.community.value}
                    placeholder={
                      schema.communityBackground.community.hint ||
                      schema.communityBackground.community.label
                    }
                    inputRef={register(
                      isValidators(schema.communityBackground.community.validators)
                    )}
                  />
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} style={Styles.marginTop3}>
                  <InputNumberForm
                    schema={schema.communityBackground.totalPopulation}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={4}
                    inputMdlg={20}
                  />
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} style={Styles.marginTop3}>
                  <InputNumberForm
                    schema={schema.communityBackground.totalHouseholds}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={4}
                    inputMdlg={20}
                  />
                </Col>
              </Row>
              <Row style={Styles.marginTop20}>
                <Col>
                  <p>
                    <b>{schema.communityBackground.vegetableGrowInfo}</b>
                  </p>
                </Col>
                <Col>
                  <InputNumberForm
                    schema={schema.communityBackground.notGrowVegetable}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={5}
                    inputMdlg={19}
                  />
                </Col>
                <Col>
                  <InputNumberForm
                    schema={schema.communityBackground.useChemicals}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={5}
                    inputMdlg={19}
                  />
                </Col>
                <Col>
                  <InputNumberForm
                    schema={schema.communityBackground.useChemicalsBudget}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={5}
                    inputMdlg={19}
                  />
                </Col>
                <Col>
                  <InputNumberForm
                    schema={schema.communityBackground.notUseChemicals}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={5}
                    inputMdlg={19}
                  />
                </Col>
                {schema.communityBackground.growVegetableType && (
                  <Col style={Styles.marginTop10}>
                    <p>
                      {requiredFiled(
                        schema.communityBackground.growVegetableType.validators,
                        schema.communityBackground.growVegetableType.label
                      )}
                    </p>

                    <Input
                      rows={3}
                      componentClass="textarea"
                      name={schema.communityBackground.growVegetableType.name}
                      defaultValue={schema.communityBackground.growVegetableType.value}
                      placeholder={
                        schema.communityBackground.growVegetableType.hint ||
                        schema.communityBackground.growVegetableType.label
                      }
                      inputRef={register(
                        isValidators(schema.communityBackground.growVegetableType.validators)
                      )}
                    />
                  </Col>
                )}
              </Row>

              <Row style={Styles.marginTop20}>
                <Col>
                  <p>
                    <b>{schema.communityBackground.vegetableConsumption}</b>
                  </p>
                </Col>
                <Col>
                  <InputNumberForm
                    schema={schema.communityBackground.notBuy}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={5}
                    inputMdlg={19}
                  />
                </Col>
                <Col>
                  <InputNumberForm
                    schema={schema.communityBackground.buyNotSafe}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={5}
                    inputMdlg={19}
                  />
                </Col>
                <Col>
                  <InputNumberForm
                    schema={schema.communityBackground.buyNotSafeBudget}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={5}
                    inputMdlg={5}
                  />
                </Col>
                {schema.communityBackground.behaviorOther && (
                  <Col style={Styles.marginTop10}>
                    <p>
                      {requiredFiled(
                        schema.communityBackground.behaviorOther.validators,
                        schema.communityBackground.behaviorOther.label
                      )}
                    </p>
                    <Input
                      name={schema.communityBackground.behaviorOther.name}
                      placeholder={
                        schema.communityBackground.behaviorOther.hint ||
                        schema.communityBackground.behaviorOther.label
                      }
                      defaultValue={schema.communityBackground.behaviorOther.value}
                      inputRef={register(
                        isValidators(schema.communityBackground.behaviorOther.validators)
                      )}
                    />
                  </Col>
                )}
              </Row>

              <Row>
                <Col style={Styles.marginTop10}>
                  <CKEditorFrom
                    schema={schema.communityBackground.editorData1}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col style={Styles.marginTop10}>
                  <CKEditorFrom
                    schema={schema.communityBackground.editorData2}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
                <Col style={Styles.marginTop10}>
                  <CKEditorFrom
                    schema={schema.communityBackground.editorData3}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>
              </Row>
            </FormGroup>
          </Form>
        </Panel>
      )}
    </>
  )
}

const Styles = {
  marginTop3: { marginTop: 3 },
  marginTop5: { marginTop: 5 },
  marginTop10: { marginTop: 10 },
  marginTop20: { marginTop: 20 },
}
